import { SyntheticEvent } from 'react';
import { Button, alpha, colors } from '@bridebook/ui';
import IconCircle from '@bridebook/ui/src/components/svg/icon-circle';
import { IconClass } from '@bridebook/web/lib/ui/constants';
import componentStyles from './delete-button.style';

interface IProps {
  onDelete: (e: SyntheticEvent) => void;
  fullBleed?: boolean;
}

const DeleteButton = ({ onDelete, fullBleed }: IProps) => {
  const styles = componentStyles({ fullBleed });

  const blackAlpha25 = alpha(colors.black, 30);

  return fullBleed ? (
    <>
      <IconCircle width={32} color={blackAlpha25} style={styles.pillBackground} />
      <Button
        theme="ghost"
        color="white"
        customHeight={32}
        customWidth={32}
        icon={<span className={IconClass.Trash} style={styles.trashIcon} />}
        onClick={onDelete}
      />
    </>
  ) : (
    <Button
      theme="ghost"
      color="white"
      icon={<span className={IconClass.Trash} style={styles.trashIcon} />}
      onClick={onDelete}
    />
  );
};

export default DeleteButton;
